import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const OPERATING_ACTIVITIES_NAMES = {
  CASH_RECEIVED_CUSTOMERS: 'cashReceivedCustomers',
  CASH_PAID_SUPPLIERS: 'cashPaidSuppliers',
  CASH_PAID_EMPLOYEES: 'cashPaidEmployees',
  CASH_PAID_OTHER_OPERATING_EXPENSES: 'cashPaidOtherOperatingExpenses',
  INTEREST_RECEIVED: 'interestReceived',
  INTEREST_PAID: 'interestPaid',
  INCOME_TAXES_PAID: 'incomeTaxesPaid',
  NET_CASH_OPERATING_ACTIVITIES: 'netCashOperatingActivities',
} as const;

export const useGetOperatingActivitiesTableHeadings = (isExamplePage: boolean) => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const operatingActivitiesFields = {
      [OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS]: {
        title: isExamplePage ? 'Cash received from customers' : t('financialPlan.projectedCashFlow.direct.operatingActivities.cashReceivedCustomers'),
      },
      [OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS]: {
        title: isExamplePage ? 'Cash paid to suppliers' :  t('financialPlan.projectedCashFlow.direct.operatingActivities.cashPaidSuppliers'),
      },
      [OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES]: {
        title: isExamplePage ? 'Cash paid to employees' :  t('financialPlan.projectedCashFlow.direct.operatingActivities.cashPaidEmployees'),
      },
      [OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES]: {
        title: isExamplePage ? 'Cash paid for other operating expenses' :  t('financialPlan.projectedCashFlow.direct.operatingActivities.cashPaidOtherOperatingExpenses'),
      },
      [OPERATING_ACTIVITIES_NAMES.INTEREST_RECEIVED]: {
        title: isExamplePage ? 'Interest received' :  t('financialPlan.projectedCashFlow.direct.operatingActivities.interestReceived'),
      },
      [OPERATING_ACTIVITIES_NAMES.INTEREST_PAID]: {
        title: isExamplePage ? 'Interest paid' :  t('financialPlan.projectedCashFlow.direct.operatingActivities.interestPaid'),
      },

      [OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID]: {
        title: isExamplePage ? 'Income taxes paid' :  t('financialPlan.projectedCashFlow.direct.operatingActivities.incomeTaxesPaid'),
      },
    };

    const totalRowTitle = t('financialPlan.projectedCashFlow.direct.operatingActivities.netCashOperatingActivities');

    return { operatingActivitiesFields, totalRowTitle };
  }, [t, i18n, isExamplePage]);
};

export interface IOperatingActivitiesType {
  [OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.INTEREST_PAID]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.INTEREST_RECEIVED]: IPeriodsTableRow;
  [OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES]: IPeriodsTableRow;
}

export const operatingActivitiesInitialValues: IOperatingActivitiesType = {
  [OPERATING_ACTIVITIES_NAMES.CASH_PAID_EMPLOYEES]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.CASH_PAID_SUPPLIERS]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.CASH_PAID_OTHER_OPERATING_EXPENSES]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.CASH_RECEIVED_CUSTOMERS]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.INTEREST_PAID]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.INCOME_TAXES_PAID]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.INTEREST_RECEIVED]: initialPeriodsTableRow,
  [OPERATING_ACTIVITIES_NAMES.NET_CASH_OPERATING_ACTIVITIES]: initialPeriodsTableRow,
};
